import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASEURL;
// const REACT_APP_BRIDGE_URL = process.env.REACT_APP_BRIDGE_URL;
// const REACT_APP_BRIDGE_URL = window.location.origin + "/api/bridge";
const REACT_APP_BRIDGE_URL = window.location.origin + "/apibridge";
//process.env.REACT_APP_BRIDGE_URL === "production"
//  ? window.location.origin + "/apibridge"
//  : process.env.REACT_APP_BRIDGE_URL;
const BASE_URL_TRACK = process.env.REACT_APP_API_TRACK;
const REACT_APP_API_EMAIL = process.env.REACT_APP_API_EMAIL;
const REACT_APP_API_MAIN = process.env.REACT_APP_API_MAIN;
const BASE_URL_TRACK_AUTH = process.env.REACT_APP_API_TRACK_AUTH;
const REACT_APP_CONTACT_URL = process.env.REACT_APP_CONTACT_URL;

// const BASE_URL_NOTIFICATION = process.env.REACT_APP_API_NOTIFICATION;
// const BASE_URL_NOTIFICATION_AUTH = process.env.REACT_APP_API_NOTIFICATION_AUTH;

const apiService = function (baseURL = BASE_URL, header = undefined) {
  const instance = axios.create({
    baseURL: `${baseURL}`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      ...header,
    },
  });

  //local
  this.post = (serviceName, params, headers = undefined) => {
    return instance.post(
      serviceName,
      { body: { ...params } },
      { headers: { ...headers } }
    );
  };
  this.get = (serviceName, headers = undefined) => {
    return instance.get(serviceName, { headers: { ...headers } });
  };

  this.bridgeApiAUTH = (serviceName, header = undefined) => {
    return instance.post(
      REACT_APP_BRIDGE_URL,
      { body: { url: `${BASE_URL_TRACK_AUTH}${serviceName}`, type: "GET" } },
      { headers: { ...header } }
    );
  };

  this.bridgeApi = (serviceName, header = undefined) => {
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `${BASE_URL_TRACK}${serviceName}`,
        type: "GET",
        headers: { ...header },
      },
    });
  };

  this.bridgeApiEmail = (serviceName, header = undefined, payload) => {
    ////${serviceName}
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `sendemail`,
        type: "POST",
        headers: { ...header },
        // param: `replyTo=${header}`,
        param: "",
        payload: { ...payload },
      },
    });
  };
  this.bridgeApiTarif = (serviceName, header = undefined, payload) => {
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `gettarif`,
        type: "POST",
        headers: { ...header },
        payload: { ...payload },
        param: "",
      },
    });
  };

  this.bridgeApiPickup = (serviceName, header = undefined, payload) => {
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `insertpickup`,
        type: "POST",
        headers: { ...header },
        payload: { ...payload },
        param: "",
      },
    });
  };

  this.bridgeApiCities = (
    serviceName,
    header = undefined,
    payload = undefined
  ) => {
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `getcities`,
        type: "GET",
        headers: { ...header },
        payload: { ...payload },
        param: "",
      },
    });
  };

  this.bridgeApiServices = (
    serviceName,
    header = undefined,
    payload = undefined
  ) => {
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `getservices`,
        type: "GET",
        headers: { ...header },
        payload: { ...payload },
        param: "",
      },
    });
  };

  this.bridgeApi = (serviceName, header = undefined, payload) => {
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `trackapinew`,
        type: "GET",
        headers: { ...header },
        payload: { ...payload },
        param: `consignee=${header}`,
      },
    });
  };

  //getBranchesByCity
  this.basicBridgeApi = (serviceName, header = undefined, payload) => {
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `getbranchesbycity`,
        type: "GET",
        headers: { ...header },
        payload: { ...payload },
        param: `city=${header}`,
      },
    });
  };

  //getAreaCode
  this.bridgeApiArea = (header = undefined, payload) => {
    console.log("header", header);
    return instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `getareacode`,
        type: "GET",
        headers: { ...header },
        payload: { ...payload },
        param: `citycode=${header}`,
      },
    });
  };

  /* this.basicBridgeApi = (header = undefined, param = 'city') => {
            const queryParams = param ? `?${param}` : ''; 
            const url = `${REACT_APP_BRIDGE_URL}/getbranchesbycity${queryParams}`;

            return instance.get(url, {
                headers: { ...header }
            });
        };
*/

  this.devBasicBridgeApi = (serviceName, header = undefined) =>
    instance.post(REACT_APP_BRIDGE_URL, {
      body: {
        url: `${"https://devconnect.tcscourier.com/customerapp/"}${serviceName}`,
        type: "GET",
        headers: { ...header },
      },
    });

  //Local

  //Live

  // this.bridgeApi = (serviceName, header = undefined) => {
  // 	return instance.post(REACT_APP_BRIDGE_URL, { body: { url: `${BASE_URL_TRACK}`, type: 'GET', headers: { ...header }, payload:{serviceName} } })
  // }

  // this.bridgeApiEmail = (serviceName, header = undefined, payload) => {
  // 	return instance.post(REACT_APP_BRIDGE_URL, { body: { url: `${REACT_APP_API_EMAIL}`, type: 'POST', headers: { ...header }, payload: { ...payload } } })
  // }
  // this.bridgeApiPickup = (serviceName, header = undefined, payload) => {
  // 	return instance.post(REACT_APP_BRIDGE_URL, { body: { url: `${REACT_APP_API_MAIN}`, type: 'POST', headers: { ...header }, payload: { ...payload } } })
  // }
  // this.bridgeApiTarif = (serviceName, header = undefined, payload) => {
  // 	return instance.post(REACT_APP_BRIDGE_URL, { body: { url: `${REACT_APP_API_MAIN}`, type: 'POST', headers: { ...header }, payload: { ...payload } } })
  // }
  // this.bridgeCitiesApi = (serviceName, header = undefined, payload) => {
  // 	return instance.post(REACT_APP_BRIDGE_URL, { body: { url: `${REACT_APP_API_MAIN}`, type: 'GET', headers: { ...header }, payload: { serviceName } } })
  // }
  // this.bridgeBranchesCityApi = (serviceName, header = undefined, payload) => {
  // 	return instance.post(REACT_APP_BRIDGE_URL, { body: { url: `${REACT_APP_API_MAIN}`, type: 'GET', headers: { ...header }, payload: { serviceName } } })
  // }

  //Live

  // this.emailbridgeApiAUTH = (serviceName, header = undefined) => {
  // 	return instance.post(REACT_APP_BRIDGE_URL, { body: { url: `${BASE_URL_NOTIFICATION_AUTH}${serviceName}`, type: 'GET' } },
  // 	 { headers: { ...header } })
  // }

  // this.emailbridgeApi = (serviceName, header = undefined) => {
  // 	return instance.post(REACT_APP_BRIDGE_URL, { body: { url: `${BASE_URL_NOTIFICATION}${serviceName}`, type: 'GET' } },
  // 	 { headers: { ...header } })
  // }

  // this.contactPost = (body, header = undefined) => {
  // 	return instance.post(REACT_APP_CONTACT_URL, { body})
  // }
};

export { apiService };
